var _a;
import { printPrefix } from "../../pages/transactions/overview/cells/printGuidance";
import ValueBase from './ValueBase';
class Value extends ValueBase {
    suffix;
    constructor(response) {
        super(response);
        this.suffix = response.suffix;
    }
    printPrice() {
        const items = [];
        if (this.prefix !== undefined) {
            const prefixText = printPrefix(this.prefix);
            items.push(prefixText);
        }
        const extraS = this.prefix !== undefined && this.prefix.length > 0;
        if (this.value !== undefined) {
            const options = extraS ? { minimumFractionDigits: 2 } : undefined;
            items.push(`${this.value.toLocaleString(undefined, options)}${extraS ? 's' : ''}`);
        }
        if (this.suffix === 'AREA') {
            items.push('area');
        }
        return items;
    }
    printYield() {
        const items = [];
        if (this.prefix !== undefined) {
            const prefixText = printPrefix(this.prefix);
            items.push(prefixText);
        }
        const extraS = this.prefix !== undefined && this.prefix.length > 0 ? 's' : '';
        if (this.value !== undefined) {
            items.push(`${this.value.toString()}%${extraS}`);
        }
        if (this.suffix === 'AREA') {
            items.push('area');
        }
        return items;
    }
    printSpread() {
        const items = [];
        if (this.prefix !== undefined && this.value !== undefined) {
            const sign = this.value > 0 ? '+' : '';
            const prefixText = printPrefix(this.prefix);
            items.push(`${sign}${prefixText}`);
        }
        const extraS = this.prefix !== undefined && this.prefix.length > 0 ? '\'s' : '';
        const sign = this.value !== undefined && this.value > 0 && this.prefix === undefined ? '+' : '';
        if (this.value !== undefined) {
            items.push(sign + this.value.toString() + extraS);
        }
        if (this.suffix === 'AREA') {
            items.push('area');
        }
        return items;
    }
    #clone() {
        return new _a(this);
    }
    updateValue(newValue) {
        const clone = this.#clone();
        clone.value = newValue;
        return clone;
    }
    updatePrefix(newValue) {
        const clone = this.#clone();
        clone.prefix = newValue;
        return clone;
    }
    updateSuffix(newValue) {
        const clone = this.#clone();
        clone.suffix = newValue;
        return clone;
    }
}
_a = Value;
export default Value;
